import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet,  httpPostReportAnalytics } from "../../services/httpService";
import {
    getPharmacyMetricThresholdUrl,
    getPhamraciesNmsMetricsUrl,
    getPhamracyNmsMetricUrl,
} from "../../apiUrls/apiUrls";

const initialState = {
    isReportLoading: false,
    isMetricReportLoading: false,
    isFilterModal: false,
    isAutoRefreshModal: false,
    isAutoRefresh: false,
    isMetricDetails: false,
    autoRefreshTime: 5,
    lastFetchedTime: new Date().toISOString(),
    initialPharmaciesNmsReport: [],
    metric: null,
    pharmaciesNmsReport: [],
    odsList: [],
    date: new Date().toISOString(),
    dateFrom: new Date().toISOString(),
    dateTo: new Date().toISOString(),
    ods: null,
};
export const getPharmacyMetricThresholdData = createAsyncThunk(
  "Reporting/getPharmacyMetricThresholdData",
  async (params) => {
    const respData = await httpGet(getPharmacyMetricThresholdUrl(params));
    return respData;
  }
);
export const getPharmacyNmsMetricsData = createAsyncThunk(
  "Reporting/getPharmacyNmsMetricsData",
  async (params) => {
    const { data } = params || {};
    const respData = await httpPostReportAnalytics(getPhamraciesNmsMetricsUrl(), data);
    return respData;
  }
);
export const getPharmacyNmsMetricData = createAsyncThunk(
  "Reporting/getPharmacyNmsMetricData",
  async (params) => {
    const { data } = params || {};
    const respData = await httpPostReportAnalytics(getPhamracyNmsMetricUrl(), data);
    return respData;
  }
);
export const reportingSlice = createSlice({
  name: "Reporting",
  initialState,
  reducers: {
    setIsReportLoading: (state, action) => {
      state.isReportLoading = action.payload;
    },
    setIsMetricReportLoading: (state, action) => {
      state.isMetricReportLoading = action.payload;
    },
    setIsFilterModal: (state, action) => {
        state.isFilterModal = action.payload;
    },
    setIsAutoRefreshModal: (state, action) => {
        state.isAutoRefreshModal = action.payload;
    },
    setIsAutoRefresh: (state, action) => {
        state.isAutoRefresh = action.payload;
    },
    setIsMetricDetails: (state, action) => {
        state.isMetricDetails = action.payload;
    },
    setAutoRefreshTime: (state, action) => {
        state.autoRefreshTime = action.payload;
    },
    setLastFetchedTime: (state, action) => {
        state.lastFetchedTime = action.payload;
    },
    setInitialPharmaciesNmsReport: (state, action) => {
        state.initialPharmaciesNmsReport = action.payload;
    },
    setPharmaciesNmsReport: (state, action) => {
        state.pharmaciesNmsReport = action.payload;
    },
    setMetric: (state, action) => {        
      state.metric = action.payload;
    },
    setOdsList: (state, action) => {
        state.odsList = action.payload;
    },
    setDate: (state, action) => {
        state.date = action.payload;
    },
    setDateFrom: (state, action) => {
        state.dateFrom = action.payload;
    },
    setDateTo: (state, action) => {
        state.dateTo = action.payload;
    },
    setOds: (state, action) => {
        state.ods = action.payload;
    },
    resetNmsState: () => initialState,
    },
});

// #region Action creators are generated for each case reducer function
export const {
    setIsReportLoading,
    setIsMetricReportLoading,
    setIsFilterModal,
    setIsAutoRefreshModal,
    setIsAutoRefresh,
    setIsMetricDetails,
    setAutoRefreshTime,
    setLastFetchedTime,
    setInitialPharmaciesNmsReport,
    setPharmaciesNmsReport,
    setMetric,
    setOdsList,
    setDate,
    setDateFrom,
    setDateTo,
    setOds,
    resetNmsState,
}= reportingSlice.actions;
// #endregion

export default reportingSlice.reducer;
